import { generateBridge } from '../Utility/GenerateBridge';

export type DebugBridgeSync = {
    enableRemoteDebugging: (commands: Record<string, string>) => void;
    log: (message: string, category: string) => void;
};

export type DebugBridgeEvents = {
    onCommand: (commandQuery: string) => void;
    onCheat: (cheatQuery: string) => void;
};

export const Debug = generateBridge({
    name: 'Debug',
    sync: { enableRemoteDebugging: undefined, log: undefined },
    async: {},
    event: { onCheat: undefined, onCommand: undefined },
});
